<template>
  <div>
    <!-- <shop-head currentPageName="REGISTER"></shop-head> -->
    <!-- 面包屑 -->
    <!-- <breadcrumb pageName="注册"></breadcrumb> -->
    <div style="width: 100%; background-color: #fff;">
      <div
        style="width: 339px; height: 239px; position: absolute; cursor: pointer"
        @click="
          () => {
            this.$router.push({
              path: '/home',
            });
          }
        "
      ></div>
      <img
        class="head-bg"
        v-if="la == 'zh'"
        src="../../assets/images/head-bg.png"
        alt=""
        style=""
      />
      <img
        class="head-bg"
        v-else
        src="../../assets/images/head-bg-en.png"
        alt=""
        style=""
      />
    </div>
    <div class="register-box">
      <img class="login-bg" src="../../assets/images/login-bg.png" alt="" />
      <el-row type="flex" justify="center">
        <el-col :md="12">
          <div class="register-form">
            <div class="register-title">{{ $t("快速注册") }}</div>
            <el-form
              ref="form"
              :model="form"
              class="form"
              :rules="rules"
              label-position="top"
            >
              <el-form-item prop="phone">
                <el-input
                  v-model="form.phone"
                  autocomplete="off"
                  prefix-icon="el-icon-phone-outline
"
                  :placeholder="$t('手机号')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="phoneCode">
                <el-input
                  v-model="form.phoneCode"
                  autocomplete="off"
                  prefix-icon="el-icon-chat-round
                "
                  :placeholder="$t('短信验证码')"
                >
                  <template slot="append"
                    ><el-button
                      :disabled="sendBtn != $t('发送验证码')"
                      @click="sendCode"
                      >{{ sendBtn }}</el-button
                    ></template
                  >
                </el-input>
              </el-form-item>
              <el-form-item prop="name">
                <el-input
                  v-model="form.name"
                  prefix-icon="el-icon-user"
                  :placeholder="$t('联系人')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="companyName">
                <el-input
                  v-model="form.companyName"
                  prefix-icon="el-icon-office-building"
                  :placeholder="$t('公司名称')"
                ></el-input>
              </el-form-item>
              <el-checkbox
                v-model="privacy"
                label=""
                class="privacy"
                fill="#ffffff"
                :indeterminate="false"
                >{{ $t("我已阅读并同意") }}
                <span style="color: #409eff" @click="goPrivacy(1)">{{
                  $t("《用户协议》")
                }}</span
                >、<span style="color: #409eff" @click="goPrivacy(2)">{{
                  $t("《隐私政策》")
                }}</span>
                {{ $t(",并授权使用该账") }}
                {{ $t("号信息（如昵称、头像、收货地址）进行管理。") }}
              </el-checkbox>
              <el-button
                type="primary"
                @click="gotoLogin"
                el-icon-office-building
                >{{ $t("注册") }}</el-button
              >
              <el-button
                type="text"
                @click="
                  () => {
                    this.$router.push({
                      path: '/login',
                    });
                  }
                "
                >{{ $t("已有账号,立即登录") }}</el-button
              >
              <!-- <div @click="gotoLogin" class="register-btn">REGISTER</div> -->
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import shopHead from "../../components/shop/head";
import commonFooter from "../../components/common/footer";
import breadcrumb from "../../components/common/breadcrumb";
import { register, phonecode } from "../../apis/user";
export default {
  components: {
    shopHead,
    commonFooter,
    breadcrumb,
  },
  data() {
    return {
      isRemember: false,
      sendBtn: "",
      privacy: false,
      la: "",
      form: {
        phone: "",
        companyName: "",
        name: "",
      },
      rules: {
        phone: [{ required: true, message: " ", trigger: "blur" }],
        name: [{ required: true, message: " ", trigger: "blur" }],
        companyName: [{ required: true, message: " ", trigger: "blur" }],
        phoneCode: [{ required: true, message: " ", trigger: "blur" }],
      },
    };
  },
  created() {
    this.la = this.$cookie.get("language") || "zh";
    this.sendBtn = this.la == "zh" ? "发送验证码" : "Send Code";
  },
  methods: {
    goPrivacy(e) {
      this.$router.push({
        path: "/privacyPolicy",
        query: {
          id: e,
        },
      });
    },
    /** 跳转到登录页 */
    gotoLogin() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.privacy) {
            this.$message({
              message: "请阅读并同意《用户协议》和《隐私政策》",
              type: "error",
            });
            return;
          }
          try {
            await register(this.form);
            this.$router.push({
              path: "/login",
            });
            this.$message({
              message: this.$i18n.t("注册成功"),
              type: "success",
            });
          } catch (e) {
            this.$message({
              message: e.message,
              type: "error",
            });
          }
          // register(this.form).then((res) => {
          //   if (res.code != 200) {
          //     this.$message({
          //       message: res.msg,
          //       type: 'danger'
          //     });
          //     return
          //   }
          //   this.$router.push({
          //     path: '/login'
          //   })
          // })
        }
      });
    },
    //发送验证码
    sendCode() {
      phonecode({ phone: this.form.phone })
        .then(() => {
          let num = 60;
          let timeer = setInterval(() => {
            this.sendBtn = `${this.$i18n.t("再次发送")}(${num--}${this.$i18n.t(
              "秒"
            )})`;
            if (num < 0) {
              clearInterval(timeer);
              this.sendBtn = this.$i18n.t("发送验证码");
            }
          }, 1000);
        })
        .catch((e) => {
          this.$message({
            message: e.message,
            type: "error",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.register-box {
  // padding: 60px 15px;
  height: 477px;

  .login-bg {
    width: 100%;
    position: absolute;
    height: 500px;
    object-fit: fill;
    left: 0px;
    margin-bottom: 20px;
  }

  .register-form {
    position: absolute;
    left: 63%;
    width: 460px;
    margin-top: 3px;
    height: 475px;
    background-color: #ffffff;
    padding: 30px;
    box-shadow: 1px 1px 5px 5px rgb(0, 0, 0, 0.1);

    .form {
      // height: 310px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .register-title {
      font-size: 20px;
      height: 50px;
      line-height: 50px;
      text-transform: capitalize;
      font-weight: 700;
      // margin-bottom: 0;
      padding-bottom: 20px;
    }
    ::v-deep .el-checkbox__label {
      white-space: normal;
    }
    ::v-deep .el-form-item {
      margin-bottom: 15px;
    }

    ::v-deep .el-form-item__label {
      font-weight: bold;
      line-height: 24px;
      margin-bottom: 12px;
      padding-bottom: 0;
    }

    ::v-deep .el-input__inner {
      border-radius: 0;

      &:focus {
        border-color: #fed100;
      }
    }
  }

  .register-btn {
    width: 140px;
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    text-align: center;
    color: #ffffff;
    display: block;
    margin-top: 30px;
    border-radius: 0;
    border: 0;
    text-transform: uppercase;
    background-color: #333333;
    cursor: pointer;

    &:hover {
      background-color: #fed100;
    }
  }
}
</style>